import axios from './httpClient';
import { getApiBaseUrl } from '../data/authStorage';

const baseUrl = getApiBaseUrl();
export const CHAT_READ_EVENT = "cehr:chat-read";

const ensureBaseUrl = () => {
  if (!baseUrl) {
    throw new Error('REACT_APP_API_BASE_URL is not configured');
  }

  return baseUrl;
};

export const listChatGroups = async () => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/chats/groups`);
  return response?.data || {};
};

export const getChatContext = async () => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/chats/context`);
  return response?.data || {};
};

export const createChatGroup = async (payload) => {
  const response = await axios.post(`${ensureBaseUrl()}/organizations/chats/groups`, payload);
  return response?.data || {};
};

export const createDirectChat = async (payload) => {
  const response = await axios.post(`${ensureBaseUrl()}/organizations/chats/groups/direct`, payload);
  return response?.data || {};
};

export const getChatGroupById = async (groupId) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/chats/groups/${groupId}`);
  return response?.data || {};
};

export const updateChatGroupMembers = async (groupId, payload) => {
  const response = await axios.patch(`${ensureBaseUrl()}/organizations/chats/groups/${groupId}/members`, payload);
  return response?.data || {};
};

export const listChatMessages = async (groupId, params = {}) => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/chats/groups/${groupId}/messages`, {
    params,
  });
  const result = response?.data || {};
  window.dispatchEvent(new CustomEvent(CHAT_READ_EVENT));
  return result;
};

export const sendChatMessage = async (groupId, payload) => {
  const hasFiles = Array.isArray(payload?.files) && payload.files.length > 0;
  let requestBody = payload;
  let config;
  if (hasFiles) {
    requestBody = new FormData();
    if (payload.body) requestBody.append('body', payload.body);
    (payload.mentionedEmployeeIds || []).forEach((id) => requestBody.append('mentionedEmployeeIds', id));
    payload.files.forEach((file) => requestBody.append('files', file));
    config = { headers: { 'Content-Type': 'multipart/form-data' } };
  }
  const response = await axios.post(`${ensureBaseUrl()}/organizations/chats/groups/${groupId}/messages`, requestBody, config);
  return response?.data || {};
};
export const deleteChatMessage = async (groupId, messageId) => {
  const response = await axios.delete(`${ensureBaseUrl()}/organizations/chats/groups/${groupId}/messages/${messageId}`);
  return response?.data || {};
};

export const listChatMentionables = async () => {
  const response = await axios.get(`${ensureBaseUrl()}/organizations/chats/mentionables`);
  return response?.data || {};
};
